// extracted by mini-css-extract-plugin
export var blushIllustration = "bC_fd";
export var button = "bC_bR";
export var cardHeadline = "bC_ff";
export var cardRoot = "bC_fc";
export var wrapper = "bC_bP";